import RequestManager from "../../../../requests/RequestManager";
import StatisticsCountryDetailsTask from "src/requests/tasks/sports/CountryDetails/statisticsCountryDetailsTask";
import { matchCompleted, matchInProgress, PARTIDO_POR_DEFINIR } from "../../constants";
import MatchCard from "../../Paises/components/CountryDetailsModal/Components/CountryDetailsBody/Components/MatchCard";
import Utils from "../../../../utils/Utils";
import Translator from "../../../../requests/apa/Translator";
import { DRAW, LOSER, WINNER } from "../../Paises/components/CountryDetailsModal/Components/constants";
import Asset from "../../../../requests/apa/Asset";

export const getMatchesCountryDetail = async (idLeague, teamViewParam, teamId) => {
    try {
        const statisticsCountryDetailsTask = new StatisticsCountryDetailsTask (idLeague, teamViewParam, teamId);
		const { response } = await RequestManager.addRequest(statisticsCountryDetailsTask);
        const {competition: {name}} = response;
        const { teamStatistics: { matchesTeams } } = response;
        const { matches = [] } = matchesTeams;

        const separator = Translator.get('eventodeportivo_carruseletapas_ficha_texto_separacion');

        return matches.map(match => ({
            id: match.matchId,
            state: getState(match),
            homeTeam: {
                name: match.homeTeam.name,
                flagUrl: match.homeTeam.name.toUpperCase() === PARTIDO_POR_DEFINIR 
                    ? Asset.get('eventodeportivo_placeholder_imagen_escudo_1') : match.homeTeam && match.homeTeam.flagUrl 
                        ? match.homeTeam.flagUrl 
                        : Asset.get('eventodeportivo_placeholder_imagen_bandera_1'),
                color: match.homeTeam.primaryHex
            },
            awayTeam:{
                name: match.awayTeam.name,
                flagUrl: match.awayTeam.name.toUpperCase() === PARTIDO_POR_DEFINIR 
                    ? Asset.get('eventodeportivo_placeholder_imagen_escudo_1') : match.awayTeam && match.awayTeam.flagUrl 
                        ? match.awayTeam.flagUrl 
                        : Asset.get('eventodeportivo_placeholder_imagen_bandera_1'),
                color: match.awayTeam.primaryHex
            },
            competition: Utils.cutPlayerString(name, 36),
            competitionGroup: `${match.stage} - ${match.group}`,
            homeScore: Utils.cutPlayerString(match.homeTeam.score, 2),
            awayScore: Utils.cutPlayerString(match.awayTeam.score, 2),
            liveTime: match.matchProgress !== null ? `${Utils.cutPlayerString(match.matchProgress.minute,11)}'` : null,    
            dateTime: Utils.cutPlayerString(`${match.displayDate} | ${match.displayTime} ${separator} ${match.timeZoneLabel}`, 24),
            status: match.status,
            result: match.isWinner ? WINNER : match.isLoser ? LOSER : DRAW,
        }))
    }catch (error) {
        console.error('Error getting matches country details:', error);
        return []
    }
}

const getState = (match) => {
    if (match.status === matchInProgress && match.broadcast.isAvailable) return MatchCard.CON_DERECHOS
    if (match.status === matchInProgress) return MatchCard.SIN_DERECHOS
    if(match.status === matchCompleted) return MatchCard.FINALIZADO
    return MatchCard.PROXIMO
}


// WEBPACK FOOTER //
// ./src/containers/Mundial2026/services/CountryDetailsServices/getMatchesCountryDetail.js